import React, { useEffect } from 'react';
import axios from 'axios';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { FacilityProvider } from './context/FacilityContext';
import ProtectedRoute from './components/ProtectedRoute';
import RequireSetup from './components/RequireSetup';

import Landing from './pages/Landing';
import SetupPage from './pages/SetupPage';
import LoginPage from './pages/LoginPage';
import ManagementDashboard from './pages/management/ManagementDashboard';
import CustomerDisplay from './pages/CustomerDisplay';

const installAxiosInterceptors = () => {
  axios.interceptors.request.use((config) => {
    try {
      const raw = localStorage.getItem('user');
      if (raw) {
        const user = JSON.parse(raw);
        if (user?.id) config.headers['x-user-id'] = user.id;
      }
    } catch (_) {}
    return config;
  });
  axios.interceptors.response.use(
    (res) => res,
    (err) => {
      if (err?.response?.status === 401) {
        localStorage.removeItem('user');
        if (!window.location.pathname.startsWith('/login') && !window.location.pathname.startsWith('/setup') && window.location.pathname !== '/') {
          window.location.assign('/login');
        }
      }
      return Promise.reject(err);
    }
  );
};

const applyInitialTheme = () => {
  try {
    const t = localStorage.getItem('posSideTheme');
    if (t === 'slate' || t === 'midnight' || t === 'light') {
      document.documentElement.setAttribute('data-theme', t);
    }
  } catch (_) {}
};

const App = () => {
  useEffect(() => { installAxiosInterceptors(); applyInitialTheme(); }, []);

  return (
    <FacilityProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/customer-display" element={<CustomerDisplay />} />
          <Route path="/setup" element={<SetupPage />} />
          <Route path="/" element={<RequireSetup><Landing /></RequireSetup>} />
          <Route path="/login" element={<RequireSetup><LoginPage /></RequireSetup>} />
          <Route
            path="/management/*"
            element={
              <RequireSetup>
                <ProtectedRoute>
                  <ManagementDashboard />
                </ProtectedRoute>
              </RequireSetup>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </FacilityProvider>
  );
};

export default App;
